/**
 * "91 (was 87)" -- the static note next to the Fit Score once an interview
 * has changed it. Same "never throw away data" pattern as
 * DimensionScoreHistory, but the Fit Score itself is a single number with
 * no justification text to disclose on demand, so a plain static note is
 * the whole design here (no CaptionInfo popover needed).
 */

import { memo } from 'react';
import styles from './index.module.css';

export interface FitScoreHistoryNoteProps {
  current: number;
  previous: number;
  /**
   * What the previous number is called. Defaults to "was", which is accurate
   * when `previous` is a score the viewer had actually been shown (the resume
   * fit score). Pass something else when it was not: Rio's rescore.scoreBefore
   * is Rio's own pre-interview figure, which can differ from the matcher score
   * the page used to display, so "was" would claim a history the viewer never
   * saw ("before interview:" does not).
   */
  label?: string;
}

export const FitScoreHistoryNote = memo(
  ({ current, previous, label = 'was' }: FitScoreHistoryNoteProps) => {
    // Nothing to disclose if the interview didn't actually move the score --
    // decided here, not left to every caller to remember to check.
    if (current === previous) return null;
    return <span className={styles.note}>{`(${label} ${previous})`}</span>;
  },
);

FitScoreHistoryNote.displayName = 'FitScoreHistoryNote';

export default FitScoreHistoryNote;
